'use client';

import React, { useCallback, useMemo, useState } from 'react';
import Pagination from './Pagination';
import Image from 'next/image';
import Link from 'next/link';

interface ImageHoverComponentProps {
    item: {
        id: number;
        title: string;
        slug: string;
        image: string;
        gif: string;
        tag: string;
        date: string;
    }[];
}

const ImageHoverShowGif: React.FC<ImageHoverComponentProps> = ({ item }) => {
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 12; // posts per page
    const postsToShow = item.slice(0, 100); // 100 posts show here
    const totalPages = Math.ceil(postsToShow.length / postsPerPage);

    const displayedPosts = useMemo(() =>
        postsToShow.slice((currentPage - 1) * postsPerPage, currentPage * postsPerPage),
        [currentPage, postsToShow]
    );

    const handlePageChange = useCallback((page: number) => {
        setCurrentPage(page);
    }, []);

    const [visiblePosts, setVisiblePosts] = useState(9);

    const handleShowMore = () => {
        setVisiblePosts((prev) => prev + 9); // Increase by 9 posts when "Show More" is clicked
    };

    return (
        <>
            <div className="row">
                {postsToShow.slice(0, visiblePosts).map((item, index) => (
                    <div key={item.slug} className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 mb-8">
                        <a
                            href={`/portfolio/${item.slug}/`}
                            aria-label={`Go to ${item.title}`}
                        >
                            <div
                                className="testimonial__slider-wrapper-2 border-2 border-gray-400 hover:text-white rounded-lg p-4 transition-shadow duration-500 transform hover:scale-105 hover:shadow-[0_4px_20px_rgba(0,0,0,0.2)]"
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                            >
                                <div className="swiper">
                                    <div className="-swiper-wrapper">
                                        <div className="swiper-slide">
                                            <div className="!mt-0 bg-none">
                                                <Image
                                                    src={hoveredIndex === index && item.gif ? item.gif : item.image}
                                                    alt={`Thumbnail of ${item.title}`}
                                                    className="rounded-md"
                                                    loading="lazy"
                                                    width={372}
                                                    height={209}
                                                    style={{
                                                        transition: 'opacity 0.3s',
                                                        objectFit: 'cover',
                                                        width: '372px',
                                                        height: '209px',
                                                    }}
                                                />
                                                <div className="p-2">
                                                    <p className="blog__meta">
                                                        <span>{item.tag.split(',')[0]}, {item.tag.split(',')[1]} </span>
                                                    </p>
                                                    <h3>
                                                        <div className="blog__title !hover:text-white">
                                                            {item.title}
                                                        </div>
                                                    </h3>
                                                    <span className="blog__btn">
                                                        Discover more
                                                        <span>
                                                            <i className="fa-solid fa-arrow-right ml-2" />
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>

                    </div>
                ))}
            </div>
            {visiblePosts < postsToShow.length && (
                <div className="text-center mb-10">
                    <button
                        onClick={handleShowMore}
                        className="px-6 py-3 bg-black text-white hover:bg-white hover:text-black border border-black rounded transition-colors duration-300"
                    >
                        Show More
                    </button>
                </div>
            )}
        </>
    );
};

export default ImageHoverShowGif;
